import PropTypes from "prop-types";
import styled from "styled-components";

const LayoutStyle = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
`;

const WrapperStyle = styled("div", {
  fluid: PropTypes.bool,
})`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh;
  transition: margin 0.3s;

  .c-subheader-fixed {
    position: relative;
  }

  .c-header-fixed {
    position: sticky;
    top: 0;
  }

  @media all and (-ms-high-contrast: none) {
    .c-header-fixed {
      position: fixed;
      margin: inherit;
    }
    .c-header-fixed {
      & ~ .c-body {
        margin-top: 104px;
      }
    }
  }

  @media all and (-ms-high-contrast: none) {
    .c-footer-fixed {
      position: fixed;
      margin: inherit;
    }
    .c-footer-fixed ~ .c-body {
      margin-bottom: 49px;
    }
  }
`;

const BodyStyle = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const MainStyle = styled.main`
  flex-basis: auto;
  flex-shrink: 0;
  flex-grow: 1;
  min-width: 0;
  padding-top: 32px;
`;

export { LayoutStyle, WrapperStyle, BodyStyle, MainStyle };
